import API_BASE_URL from '../config/apiConfig';
import createApiClient from '../config/apiClient';

const apiClient = createApiClient(API_BASE_URL);
const API_URL = '/home-sections';

const homeSectionService = {
  // Customer route - lấy danh sách sections visible (public)
  async getVisibleForCustomer() {
    try {
      const response = await apiClient.get(`${API_URL}/customer`);
      return response.data;
    } catch (error) {
      console.error('Error fetching visible home sections:', error);
      throw error;
    }
  },

  // Admin routes
  // Lấy danh sách tất cả sections
  async getAll() {
    try {
      const response = await apiClient.get(`${API_URL}/admin`);
      return response.data;
    } catch (error) {
      console.error('Error fetching home sections:', error);
      throw error;
    }
  },

  // Lấy section theo ID
  async getById(id) {
    try {
      const response = await apiClient.get(`${API_URL}/admin/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching home section:', error);
      throw error;
    }
  },

  // Tạo section mới
  async create(data) {
    try {
      const response = await apiClient.post(`${API_URL}/admin`, data);
      return response.data;
    } catch (error) {
      console.error('Error creating home section:', error);
      throw error;
    }
  },

  // Cập nhật section
  async update(id, data) {
    try {
      const response = await apiClient.put(`${API_URL}/admin/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating home section:', error);
      throw error;
    }
  },

  // Xóa section
  async delete(id) {
    try {
      const response = await apiClient.delete(`${API_URL}/admin/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting home section:', error);
      throw error;
    }
  },

  // Sắp xếp lại thứ tự
  async reorder(orders) {
    try {
      const response = await apiClient.post(`${API_URL}/admin/reorder`, { orders });
      return response.data;
    } catch (error) {
      console.error('Error reordering home sections:', error);
      throw error;
    }
  }
};

export default homeSectionService;

